// extracted by mini-css-extract-plugin
export var text = "_4p-0";